import { atom } from 'jotai';

export const fileUploaderAtoms = {
  isUploading: atom<boolean>(false),
};

export const isUploadingDisabledMessage =
  'Cannot start a new upload before the previous one has completed.';
